var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',_vm._g(_vm._b({},'b-alert',_vm.$props,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }